import { IMakeModelTiers } from "interfaces/cms/static-content";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import withErrorHandler from "../design-system/withErrorHandler";
const CategoryMakesModel = dynamic(() => import(/* webpackChunkName: "category-makes-model" */"../landing-page/CategoryMakesModel"));

interface IMakeModeTierInterLinking {
  makeModelTiers: IMakeModelTiers,
  pageDetails: any,
}

function MakeModeTierInterLinking(props: IMakeModeTierInterLinking) {
  const { makeModelTiers = {}, pageDetails = {} } = props;
  const { content } = makeModelTiers;
  const { locale, query } = useRouter();

  if (!process.browser) {
  // TODO fix this when page https://partsavatar.ca/fr/brake-pad-sets
  // gets open
    if (locale === "fr") {
      return null;
    }

    // fix SSR issue for /rear-shocks-struts and /rear-shocks
    if (query.pathname === "rear-shocks-struts"
    || query.pathname === "rear-shocks") {
      return null;
    }
  }

  if (!content || !content.length) {
    return null;
  }
  /**
   * add label, .
   * sort popular at start,
   * sort makes based on models length
   */
  const category = pageDetails.tier3 || pageDetails.tier2;
  const dataTransform = content
    .map((_) => ({
      ..._,
      models: [..._.models
        .sort((a: any) => !a.popular)
        .map((model: any) => ({
          ...model,
          category,
          popular: true,
        })), {
        url: _.url || _.makeCategoryUrl,
        img: createMakeImageSource({ make: _.make.toUpperCase() }),
        displayableModel: `All ${_.make}`,
        category,
        isMake: true,
        popular: true,
      }],
    }))
    .sort((a: any, b: any) => b.models.length - a.models.length);

  return (
    <CategoryMakesModel {...{
      heading: category ? `${category} for Popular Models` : "Popular Models",
      data: dataTransform,
    }}
    />
  );
}

export default withErrorHandler(MakeModeTierInterLinking);
